import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45ff41c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "c-pagination-container"
}
const _hoisted_2 = { class: "left-area" }
const _hoisted_3 = { class: "total-text" }
const _hoisted_4 = { class: "right-area" }
const _hoisted_5 = { class: "c-pagination" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1681108733822",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4295",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M714.608 41.074L265.584 490.097c-10.963 10.963-11.993 28.099-3.083 40.21899999l0.06099999 0.07900001a31.629 31.629 0 0 0 1.55500001 1.926c0.47 0.539 0.954 1.07000001 1.468 1.584L714.608 982.927c12.098 12.097 31.71 12.097 43.808 0 12.097-12.096 12.097-31.71 0-43.807L331.296 512l427.11900001-427.12c12.097-12.096 12.097-31.71-1e-8-43.807-12.097-12.097-31.708-12.097-43.807 0.001z",
    "p-id": "4296",
    fill: "#999999"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "jump-dot" }, "•••", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "double-left-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1681119234578",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "6335",
    width: "16",
    height: "16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M842.666667 864c-8.533333 0-14.933333-2.133333-21.333334-8.533333l-341.333333-309.333334c-6.4-6.4-10.666667-14.933333-10.666667-23.466666 0-8.533333 4.266667-17.066667 10.666667-23.466667l341.333333-309.333333c12.8-12.8 34.133333-10.666667 44.8 2.133333 12.8 12.8 10.666667 34.133333-2.133333 44.8L548.266667 522.666667l315.733333 285.866666c12.8 10.666667 14.933333 32 2.133333 44.8-6.4 6.4-14.933333 10.666667-23.466666 10.666667z",
      fill: "#1890ff",
      "p-id": "6336"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M512 864c-8.533333 0-14.933333-2.133333-21.333333-8.533333L149.333333 546.133333c-6.4-6.4-10.666667-14.933333-10.666666-23.466666 0-8.533333 4.266667-17.066667 10.666666-23.466667L490.666667 189.866667c12.8-12.8 34.133333-10.666667 44.8 2.133333 12.8 12.8 10.666667 34.133333-2.133334 44.8L217.6 522.666667 533.333333 808.533333c12.8 12.8 14.933333 32 2.133334 44.8-6.4 6.4-14.933333 10.666667-23.466667 10.666667z",
      fill: "#1890ff",
      "p-id": "6337"
    })
  ])
], -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "jump-dot" }, "•••", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "double-right-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1681119704968",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "7607",
    id: "mx_n_1681119704969",
    width: "16",
    height: "16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M544 522.666667c0-8.533333-4.266667-17.066667-10.666667-23.466667L192 189.866667c-12.8-12.8-34.133333-10.666667-44.8 2.133333-12.8 12.8-10.666667 34.133333 2.133333 44.8l315.733334 285.866667L149.333333 808.533333c-12.8 12.8-14.933333 32-2.133333 44.8 6.4 6.4 14.933333 10.666667 23.466667 10.666667 8.533333 0 14.933333-2.133333 21.333333-8.533333l341.333333-309.333334c6.4-6.4 10.666667-14.933333 10.666667-23.466666z",
      fill: "#1890ff",
      "p-id": "7608"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M864 499.2l-341.333333-309.333333c-12.8-12.8-34.133333-10.666667-44.8 2.133333-12.8 12.8-10.666667 34.133333 2.133333 44.8l315.733333 285.866667-315.733333 285.866666c-12.8 12.8-14.933333 32-2.133333 44.8 6.4 6.4 14.933333 10.666667 23.466666 10.666667 8.533333 0 14.933333-2.133333 21.333334-8.533333l341.333333-309.333334c6.4-6.4 10.666667-14.933333 10.666667-23.466666 0-8.533333-4.266667-17.066667-10.666667-23.466667z",
      fill: "#1890ff",
      "p-id": "7609"
    })
  ])
], -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1681108801546",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "5320",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M778.541176 490.706824L352.557176 64.752941a30.117647 30.117647 0 0 0-42.586352 42.586353L714.631529 512 310.061176 916.570353a30.087529 30.087529 0 0 0-0.060235 42.646588 29.967059 29.967059 0 0 0 42.646588-0.030117l425.833412-425.86353a30.087529 30.087529 0 0 0 0.030118-42.61647z",
    fill: "#999999",
    "p-id": "5321"
  })
], -1))
const _hoisted_16 = [
  _hoisted_15
]

import { computed } from 'vue';
import CSelect from '../cSelect/CSelect.vue';
interface CPaginationProps {
  current?: number,
  pageSize?: number,
  total?: number,
  //页码按钮的数量，当总页数超过该值时会折叠
  pageCount?: number
}

const __default__ = {
  name:'CPagination'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    current: { default: 1 },
    pageSize: { default: 20 },
    total: { default: 0 },
    pageCount: { default: 7 }
  },
  emits: ['change', 'update:current', 'update:pageSize'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const operation = [
  {
    title: '10条/页',
    value: 10
  },
  {
    title: '20条/页',
    value: 20
  },
  {
    title: '50条/页',
    value: 50
  },
  {
    title: '100条/页',
    value: 100
  },
]
//总页数
const totalPage = computed(() => {
  return Math.ceil(props.total / props.pageSize)
})
const nums = computed(() => {
  return Math.floor((props.pageCount - 3) / 2)
})
//
const pageList = computed(() => {
  const listTotal = totalPage.value;
  let count = props.pageCount;
  let list: number[] = [];
  const num = nums.value
  if (listTotal <= count) {
    for (let i = 0; i < listTotal - 2; i++) {
      list.push(i + 2);
    }
  } else {
    if ((props.current - num - 1) <= 1) {
      // 从2开始
      for (let i = 0; i < count - num; i++) {
        list[i] = i + 2;
      }
    } else if ((props.current + num + 1) >= listTotal) {
      // 从listTotal减小
      for (let i = 0; i < count - num; i++) {
        list[i] = listTotal - (count - num - i);
      }
    } else {
      // 左边
      for (let i = 0; i < num; i++) {
        list[i] = props.current - (num - i);
      }
      // 中间数
      list[num] = props.current;
      // 右边数
      for (let i = 0; i < num; i++) {
        list[num + 1 + i] = props.current + i + 1;
        // console.log(num + 2 + i);
      }
    }
  }
  // console.log(list, 'list');
  return list
})
const prevPage = () => {
  if (props.current > 1) {
    emit('update:current', props.current - 1)
    pageChange(props.current - 1)
  }
}
const nextPage = () => {
  if (props.current < totalPage.value) {
    emit('update:current', props.current + 1)
    pageChange(props.current + 1)
  }
}
const pageChange = (count) => {
  emit('update:current', count)
  emit('change', {
    pageIndex: count,
    pageSize: props.pageSize
  })
}
const handlePage = (item) => {
  if (item === props.current) return
  emit('update:current', item);
  emit('change', {
    pageIndex: item,
    pageSize: props.pageSize
  })
}
const prevEllipsisClick = () => {
  if (props.current === totalPage.value) {
    handlePage(props.current - nums.value - 2);
  }
  else {
    handlePage(props.current - nums.value);
  }
}
const nextEllipsisClick = () => {
  if (props.current === 1) {
    handlePage(props.current + nums.value + 2);
  }
  else {
    handlePage(props.current + nums.value);
  }
}
const onPageSizeChange = (val) => {
  // console.log(val)
  emit('update:pageSize', val)
  emit('change', {
    pageIndex: props.current,
    pageSize: val
  })
}

return (_ctx: any,_cache: any) => {
  return (_ctx.total)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, "当前显示" + _toDisplayString(_ctx.total > _ctx.pageSize ? _ctx.pageSize : _ctx.total) + "条数据", 1),
          _createElementVNode("span", null, "共" + _toDisplayString(totalPage.value) + "页", 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["c-pagination-prev", { 'no-drop': _ctx.current == 1 }]),
              onClick: prevPage
            }, _hoisted_7, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["c-pagination-item", { 'active': _ctx.current == 1 }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (pageChange(1)))
            }, "1", 2),
            (_ctx.current - nums.value - 1 > 1 && totalPage.value > _ctx.pageCount)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "c-pagination-jump-prev",
                  onClick: prevEllipsisClick
                }, _hoisted_10))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageList.value, (count) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["c-pagination-item", { 'active': count == _ctx.current }]),
                key: count,
                onClick: ($event: any) => (pageChange(count))
              }, _toDisplayString(count), 11, _hoisted_11))
            }), 128)),
            (_ctx.current + nums.value + 1 < totalPage.value && totalPage.value > _ctx.pageCount)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "c-pagination-jump-next",
                  onClick: nextEllipsisClick
                }, _hoisted_14))
              : _createCommentVNode("", true),
            (totalPage.value > 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(["c-pagination-item", { 'active': _ctx.current == totalPage.value }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (pageChange(totalPage.value)))
                }, _toDisplayString(totalPage.value), 3))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["c-pagination-next", { 'no-drop': _ctx.current == totalPage.value }]),
              onClick: nextPage
            }, _hoisted_16, 2),
            _createVNode(CSelect, {
              options: operation,
              value: _ctx.pageSize,
              onChange: onPageSizeChange,
              "input-style": { width: '95px' }
            }, null, 8, ["value"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})